import CustomShaderMaterial from "three-custom-shader-material";
import { MeshStandardMaterial } from "three";
import type { MaterialProp } from "../Spices";
import { MAX_SPICES } from "@/data/schema";
import { useEffect, useMemo, useRef } from "react";

export function MixMat({ uniforms }: MaterialProp) {
  return (
    <CustomShaderMaterial
      baseMaterial={MeshStandardMaterial}
      /* glsl */
      vertexShader={`
        varying vec2 vUv; 
        void main() {vUv = uv;} 
      `}
      /* glsl */
      fragmentShader={`
        // constants
        #define MAX ${MAX_SPICES}

        // uniforms
        uniform int uActiveCount; 
        uniform float uQuantity[MAX];
        uniform int uActiveTextureSlots[MAX]; 
        uniform bool uHighResMapsReady[MAX]; 

        // // textures
        uniform sampler2DArray uTexture;
        uniform sampler2DArray uNormal;
        uniform sampler2DArray uFallback; 

        // // props
        uniform float uTextureScale[MAX]; 
        uniform float uNorIntensity[MAX];
        uniform float uRoughnessIntensity[MAX]; 

        // // varyings
        varying vec2 vUv;

        void main() {
        vec3 color = vec3(0.0);
        vec3 nor = vec3(0.0);  
        float rough = 0.0; 

        for(int i = 0; i < uActiveCount; i++) 
        {

          int slot = uActiveTextureSlots[i]; 

          if(uHighResMapsReady[i])
          {
          vec4 tex = texture(uTexture, vec3(vUv * uTextureScale[i], float(slot))) * uQuantity[i];            
          vec4 norMap = texture(uNormal, vec3(vUv * uTextureScale[i], float(slot))) * uQuantity[i];     
          norMap.rgb = norMap.rgb * 2.0 - 1.0;
          norMap.rgb = mix(vec3(0.0, 0.0, 1.0), norMap.rgb, uNorIntensity[i]);

          nor += norMap.rgb;  // Apply mask AFTER conversion
          color += tex.rgb;              
          rough += pow(norMap.a, uRoughnessIntensity[i]) ;       
          }
          
          else 
          {
            color += texture(uFallback, vec3(vUv * uTextureScale[i], float(slot))).rgb * uQuantity[i]; 
          }
    
        } 

        csm_DiffuseColor = vec4(color, 1.0); 
        csm_FragNormal   = normalize(nor); 
        csm_Roughness    = rough; 

        }

      `}
      uniforms={uniforms}
    />
  );
}
